import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LoadingOverlay from "react-loading-overlay";
import ModalHeader from "../header/subHeader";
import size from "lodash/size";
import { Spinner, SpinnerSize } from "office-ui-fabric-react";
import Select from "react-select";
import { getPrimaryRedTheme } from "../../../../common/themes";
import Confirm from "../../common/confirm/confirm";
import { RouteComponentProps } from "react-router-dom";
import { IProject, IApplicationState, IUserEndPoint,IResFunctions } from "../../../../models/applicationState";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import IUserDefinedActions, * as userDefinedActions from "../../../../redux/actions/userDefinedActions";
import HeaderComponent from "../header/header";
import SplitPane from "react-split-pane";
import JsonResponse from "./jsonResponse";
import "./userValidations.scss";
import ServiceHelper from "../../../../services/serviceHelper";
import { toast } from "react-toastify";
import axios from "axios";


import { accessTokenData, accessToken, refreshTokenEndPoint, refreshTokenCall } from '../../../../common/api-config'
import { InputGroup } from "reactstrap";

import base64 from "base-64";

export interface IUserFunctionsProps extends RouteComponentProps, React.Props<UserFunctions> {
    project: IProject;
    actions: IProjectActions;
    userDefinedActions: IUserDefinedActions;
    recentProjects: IProject[];
}

function mapStateToProps(state: IApplicationState) {
    return {
        project: state.currentProject,
        recentProjects: state.recentProjects,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        userDefinedActions: bindActionCreators(userDefinedActions, dispatch),
    };
}

export interface IUserFunctionsState {
    addEndPoint: boolean;
    userTransformations: IUserEndPoint[];
    userATransformations: IUserEndPoint[];
    project: IProject;
    project_name: string;
    validationIndex: any;
    loadEndPoints: boolean;
    createValidation: boolean;
    endpoint: string;
    validationCheck: any;
    deleteEndPoint: boolean;
    endpoint_name: string;
    labelString: string;
    userEnabledDisableEndPoint: boolean;
    status: any;
    category: any;
    analyzeResult: any;
    orderResult: IResFunctions[];
    UDTResult:any;
    apiCompleted: boolean;
    vinInvoice:string;
}

@connect(mapStateToProps, mapDispatchToProps)

export default class UserFunctions
    extends React.Component<IUserFunctionsProps, IUserFunctionsState> {
    public state: IUserFunctionsState = {
        addEndPoint: false,
        project: this.props.project,
        project_name: null,
        endpoint_name: null,
        endpoint: null,
        userTransformations: [],
        deleteEndPoint: false,
        createValidation: false,
        validationCheck: true,
        category: null,
        labelString: "updating End Point",
        validationIndex: null,
        userEnabledDisableEndPoint: false,
        loadEndPoints: false,
        status: null,
        analyzeResult: null,
        orderResult: [],
        UDTResult:null,
        userATransformations: [],
        apiCompleted:true,
        vinInvoice:null,
    };

    private onDeleteEndPointConfirm: React.RefObject<Confirm> = React.createRef();
    private renameCanceled: () => void;
    private cancelToken;
    public componentDidMount() {
        const projectName = this.props.match.params["projectName"];
      // debugger;
        this.getValidationsTransform(projectName);

        // new code for prediction result
      //  window.addEventListener("focus", this.onFocused);
       //// const user = this.props.loggedInUser;
       // const userId = user.user.oid;
       // this.setState({ userId });
      //  this.isUnmount = false;
        const projectId = this.props.match.params["projectId"];
       // debugger;
        //const projectName = this.props.match.params["projectName"];
        if (this.props.project) {
             
            this.setState({ analyzeResult:this.props.project.analyzeResult});

             //Load end points

           // this.loadProjectAssets();
        } else if (projectId) {
            const recentProject = this.props.recentProjects.find((project) => project.id === projectId);
            const projectCopy = Object.assign({}, recentProject);
           // projectCopy.folderPath = `${projectName}-${userId}/testing`;
           this.setState({ analyzeResult:projectCopy.analyzeResult});
            // this.props.actions.saveProject(projectCopy, false, false);
           // this.props.actions.loadProject(projectCopy);

            //Load end points
        }
        //
    }

    public render() {
      //  debugger;
        const { endpoint_name, endpoint, status, validationCheck, analyzeResult, userTransformations, category, orderResult } = this.state;
        const options = [
            { value: "enable", label: "Enable" },
            { value: "disable", label: "Disabled" },
        ];

        const epoptions = [
            { value: "AUTH", label: "Authentication" },
            { value: "UDT", label: "UDT" },
            { value: "SAP", label: "SAP" },
        ];
        return (
            <>
                <div className="container1">

                    <div className="row mt-2">
                    <div className="col-md-3 commonspace text-center">
                    <label>DCap Output</label>
                    
                        </div>
                        <div className="col-md-6 commonspace">
                            <div className="float-left text-center leftMarginFunction">
                                Functions
                            </div>
                            <div className="float-right">
                                <div className="input-group input-group-sm  float-right"><div className="input-group-prepend"><span className="input-group-text" id="inputGroup-sizing-sm">Add Function</span></div><div className="input-group-append"><button className="btn-add-row-col" type="button" onClick={() => this.showForm()}> <i className="fa fa-plus" aria-hidden="true"> </i> </button></div></div>
                            </div>

                        </div>
                        <div className="col-md-3 commonspace text-center">
                        <label>Output Messages</label>
                      
                        </div>
                    </div>

                    <div className="row">
                    <div className="col-md-3 commonspace">
                    <div className="sec-rt">
                    {this.state.analyzeResult &&    
                                            <JsonResponse
                                                history={this.props.history}
                                                match={this.props.match}
                                                location={this.props.location}
                                                project={this.props.project}
                                                outPutFormat= "JSON Response"
                                                jsonData={this.state.analyzeResult}
                                            />     
                    }                                 
                                        
                                    </div>
                         </div>
                        <div className="col-md-6 commonspace">
                            <div className="advanced-card wrap-userdefined">

                                {!this.state.loadEndPoints ?
                                    <>
                                        {size(userTransformations) > 0 ?
                                            userTransformations.map((data, index) => {
                                                return (
                                                    <div key={index}>
                                                        {this.state.validationIndex !== index &&
                                                            <div className="tile" >
                                                                <div className="s-no">{index + 1}</div>
                                                                <div className="s-noleft">{data.category}</div>
                                                                <a role="button" onClick={() => this.deleteEndPoint(data, index)} className="cursor-pointer del">
                                                                    <i
                                                                        className="fa fa-trash bg-color-1"
                                                                        aria-hidden="true"
                                                                    ></i>
                                                                </a>

                                                                <div className="custom-control custom-switch switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        value={data._id}
                                                                        onChange={(event) => this.changeEndPointStatus(event, data, index)}
                                                                        checked={data.active_status === "enable" ? true : false}
                                                                        className="custom-control-input"
                                                                        id={`customSwitch1${index + 1}`}
                                                                    />
                                                                    <label
                                                                        className="custom-control-label"
                                                                        htmlFor={`customSwitch1${index + 1}`}
                                                                    >
                                                                        {" "}
                                                                    </label>
                                                                </div>

                                                                <div>
                                                                    <span className="name">{data.endpoint_name}</span>
                                                                </div>
                                                                <div className="mt-2">
                                                                    <div className="mt-2 url_css" title={data.endpoint}>

                                                                        <i className="fa fa-link" aria-hidden="true"></i> {data.endpoint}
                                                                    </div>
                                                                </div>
                                                                 
                                                            
                                                            </div>
                                                        }
                                                        {this.state.userEnabledDisableEndPoint
                                                            && this.state.validationIndex === index && <Spinner className="tile" size={SpinnerSize.small} label={this.state.labelString} ariaLive="off" labelPosition="right" />}
                                                    </div>
                                                );
                                            })
                                            : <div className="text-center mt-5">No Data Available</div>}
                                    </>
                                    : <Spinner className="mt-5" label="Loading Endpoints" size={SpinnerSize.small} />
                                }
                            </div></div>
                          
                            <div className="col-md-3 commonspace"> 
                            <div className="tag-input-toolbar test-conttols">  

                            <div className="row fullwidth">
                                <div className="col-md-4 commonspace">

                                </div>
                                <div className="col-md-4 commonspace">


                            <div className="text-center">                                        
                                            <button
                                             disabled={userTransformations.length<1}
                                             onClick={() => this.getResultsData("raw")} 
                                                className="btn-custom">
                                                <i className="fa fa-code" aria-hidden="true"></i> Process
                                            </button>
                                            </div>
                                            
</div>
                                <div className="col-md-4 commonspace">
                                </div>
                            </div>
                                           
                                            
                                          { /* <button type="button"
                                              disabled={userTransformations.length<3}
                                             title="Export1" className="btn-custom" >
                            <i className="fa fa-file-export" aria-hidden="true"></i>Export </button>*/}
                                        </div>
{
                                        this.state.apiCompleted?
                            <div className="sec-rt">
                            {
                            this.state.orderResult &&
                             <div className="card shadow">
                                 <div className="wrap-test-right-sec"  >

                                 {
                                  
                                            orderResult.map((data, index) => {
                                                return (
                                                    <div key={index}>
                                                         <div className="ntile" >
                                                        
                                                                <div className="s-noright">{data}</div>
                                                                </div>
                                                        </div>);
                                            })
                                            }



                                     </div>
                                 </div>
                            
                            }
                                               </div>
                                               :
                                               <div>

                                               <Spinner className="mt-5" label="Loading Results" size={SpinnerSize.small} />
                                               </div>
    }


                            
               
                </div>
</div>
               
               </div>
                {this.state.addEndPoint &&
                    <div className="model_add">
                        <LoadingOverlay
                            active={this.state.createValidation}
                            spinner
                            text="Creating Validation">
                            <div className="row ">

                                <div className="col-md-6 offset-md-3">
                                    <div className="card shadow">

                                        <div className="card-header">
                                            <div className="text-center">
                                                <h5>Add Function</h5>

                                            </div>
                                        </div>

                                        <div className="card-body">

                                            <div className="row">

                                                <div className="col-md-6" >
                                                    <label >Endpoint name:</label>
                                                    <input type="text" className="form-control" id="endpoint_name" name="endpoint_name"
                                                        onChange={this.getInputValues} placeholder="Endpoint name" />
                                                </div>

                                                <div className="col-md-6" >
                                                    <label>Endpoint:</label>
                                                    <input type="text" className="form-control" id="endpoint" name="endpoint"
                                                        onChange={this.getInputValues} placeholder="" />
                                                    {!validationCheck && <div className="text-danger"> Give valid End Point</div>}
                                                </div>
{ /*                                               <div className="col-md-6" >
                                                    <label>Category:</label>
                                                    <input type="text" className="form-control" id="category" name="category"
                                                        onChange={this.getInputValues} placeholder="Category" />
                                                </div>
                */ }
                  <div className="col-md-6" >
                                                    <label>Category:</label>
                                                    <Select options={epoptions}
                                                        onChange={this.getCatStatus}
                                                        value={this.state.category}
                                                        placeholder="Select"
                                                        className="react-select-container zindex-20"
                                                        isClearable={true}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#161a1f",
                                                                primary: "#6b727d",
                                                                neutral0: "#222830",
                                                                neutral20: "#44474c",
                                                                neutral30: "#272c33",
                                                                neutral50: "#fff",
                                                                neutral80: "#9da7b5",
                                                            },
                                                        })}

                                                    />
                                                    
                                                </div>
                                                <div className="col-md-6" >

                                                    <label>Status:</label>
                                                    <Select options={options}
                                                        onChange={this.getStatus}
                                                        value={this.state.status}
                                                        placeholder="Select"
                                                        className="react-select-container zindex-20"
                                                        isClearable={true}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#161a1f",
                                                                primary: "#6b727d",
                                                                neutral0: "#222830",
                                                                neutral20: "#44474c",
                                                                neutral30: "#272c33",
                                                                neutral50: "#fff",
                                                                neutral80: "#9da7b5",
                                                            },
                                                        })}

                                                    />

                                                </div>

                                                <div className="col-md-6" >

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                    <div className="card-footer text-center">
                                        <button type="submit"
                                            onClick={this.createValidation}
                                            disabled={!endpoint_name || !endpoint || !status || !validationCheck || !category }
                                            className="btn btn-sm mr-2">Add</button>
                                        <button type="button"
                                            className="btn btn-sm" onClick={() => this.showForm()}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </LoadingOverlay>
                    </div>
                }
                <Confirm title="Delete this Validation"
                    ref={this.onDeleteEndPointConfirm}
                    message="Are you sure you want to delete this Validation ?"
                    confirmButtonTheme={getPrimaryRedTheme()}
                    onCancel={this.onCancelDeleteEndPoint}
                    onConfirm={this.confirmDeleteEndPoint} />
            </>
        );
    }
    /**
     * get validations and transform
     */
    private getValidationsTransform = async (projectName) => {
      //  debugger;
        this.setState({ loadEndPoints: true, project_name: projectName });
        if (projectName) {
            const endPointType = {
                project_name: projectName,
                endpoint_type: "transformation",
            };

            // new changes start
         
       const loadEndPointData = await this.props.userDefinedActions.loadEndPoints(endPointType);
       // const loadEndPointData = this.state.userTransformations;

      //   console.log("end points"+ JSON.stringify(loadEndPointData));
      //   console.log("end points1"+ loadEndPointData);
         // new changes end
           // const loadEndPointData = await this.props.userDefinedActions.loadEndPoints(endPointType);
            if (loadEndPointData) {
                this.setState({ userTransformations: loadEndPointData, loadEndPoints: false });
            } else {
                this.setState({ loadEndPoints: false });
            }
            // this.props.userDefinedActions.loadEndPoints(endPointType).then((data) => {
            //     this.setState({ userTransformations: data, loadEndPoints: false });
            // }).catch(() => {
            //     this.setState({ loadEndPoints: false });
            // });
        }
    }

    private getStatus = (event) => {
        if (event) {
            this.setState({ status: event });
        }
    }

    
    private getCatStatus = (event) => {
        if (event) {
            this.setState({ category: event });
        }
    }
    /**
     * show Form
     */
    private showForm = () => {
        const { addEndPoint } = this.state;
        this.setState({ addEndPoint: !addEndPoint });
    }
    /**
     * get endpoint check
     */
    private changeEndPointStatus = async (event, data, index) => {
        //debugger;
        this.setState({ userEnabledDisableEndPoint: true, validationIndex: index });
        const endPointData = {
            project_name: data.project_name,
            endpoint_type: "transformation",
            endpoint_name: data.endpoint_name,
            active_status: event.target.checked ? "enable" : "disable",
        };
        const result = await this.props.userDefinedActions.enableDisableEndPoint(endPointData);
        if (result) {

            /*
            const elementIndex = this.state.userTransformations.findIndex((element) => element._id === data._id);
            const newArray = [...this.state.userTransformations];
          //  newArray[elementIndex] = { ...newArray[elementIndex], active_status: result };
          newArray[elementIndex] = { ...newArray[elementIndex], active_status: endPointData.active_status };
          this.setState({ userTransformations: newArray, userEnabledDisableEndPoint: false, validationIndex: null });

          */
         this.getValidationsTransform(endPointData.project_name);  
         this.setState({ userEnabledDisableEndPoint: false, validationIndex: null });
        } else {
            this.setState({ userEnabledDisableEndPoint: false, validationIndex: null });
        }
    }
    /**
     * Create Validation
     */
    private createValidation = async () => {
       
        this.setState({ createValidation: true });
        const { endpoint_name, endpoint, category, status, userTransformations } = this.state;
        const endPointData = {
            project_name: this.props.match.params["projectName"],
            endpoint_type: "transformation",
            category:category.value ,
            active_status: status.value,
        };
        const body = {};
        body["endpoint_name"] = endpoint_name;
        body["endpoint"] = endpoint;

//new change start
let noofrows;
if(userTransformations)
 noofrows = userTransformations.length+1;
else
noofrows=1;

const newendPointData = {
      
    _id: noofrows,
    active_status: status.value,
    category : category.value,
    endpoint: endpoint,
    endpoint_type: "transformation",
    endpoint_name: endpoint_name,
    project_name: this.props.match.params["projectName"],
    updated_date: new Date().toDateString(),
};

//userTransformations.push(newendPointData);
//this.setState({ userTransformations: userTransformations });
//new change end

      await this.props.userDefinedActions.createEndPoint(endPointData, body);
        this.setState({ endpoint: null, endpoint_name: null, status: null, category: null, createValidation: false, addEndPoint: false });
        this.getValidationsTransform(endPointData.project_name);
    }
    /**
     * get event values based on name
     */
    private getInputValues = (event) => {
        if (event.target.name === "endpoint") {
        // const regexQuery = "^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$";
            
            const regexQuery =  "^((http|https)://)?"
              + "[a-zA-Z0-9@:%._\\+~#?&//=]"
              + "{2,256}\\.[a-z]"
              + "{2,6}\\b([-a-zA-Z0-9@:%"
              + "._\\+~#?&//=]*)$"; 
            const url = new RegExp(regexQuery, "i");
           // if (url.test(event.target.value)) {
            if (event.target.value) {
                this.setState({ ...this.state, validationCheck: true, [event.target.name]: event.target.value });
            } else {
                this.setState({ validationCheck: false });
            }
        } else {
            this.setState({ ...this.state, [event.target.name]: event.target.value });
        }
    }
    /**
     * Delete Validation
     */
    /** delete file */
    private deleteEndPoint = (endPoint: IUserEndPoint, index) => {
        this.onDeleteEndPointConfirm.current.open(endPoint, index);
    }
    /**
     * on Cancel Delete EndPoint
     */
    private onCancelDeleteEndPoint = () => {
        if (this.renameCanceled) {
            this.renameCanceled();
            this.renameCanceled = null;
        }
    }
    /**
     * Confirm Delete End Point
     */
    private confirmDeleteEndPoint = async (endPoint: IUserEndPoint, index) => {

       // debugger;
        const endPointData = {
            project_name: endPoint.project_name,
            endpoint_type: "transformation",
            endpoint_name: endPoint.endpoint_name,
            endpoint:endPoint.endpoint,
        };
        this.setState({ userEnabledDisableEndPoint: true, labelString: "Deleting End Point", validationIndex: index });
        await this.props.userDefinedActions.deleteEndPoint(endPointData);
        /*
        const newArray = [...this.state.userTransformations];
        const index_endPoint = await newArray.indexOf(endPoint);
        if (index_endPoint > -1) {
            newArray.splice(index_endPoint, 1);
        }
        this.setState({ userTransformations: newArray, userEnabledDisableEndPoint: false });
        */
       this.getValidationsTransform(endPointData.project_name);  
       this.setState({ userEnabledDisableEndPoint: false, validationIndex: null });
       this.setState({   userEnabledDisableEndPoint: false });

    }

    
    /** Analyse data from azure */
    private getResultsData = async (outPutFormat?: string) => {

        const errorSAPMessage = "Error while processing the SAP End point";
        const errorUDTMessage = "Error while processing the UDT End point";

         const headers = accessToken();
         const accessTokenBody = accessTokenData();
        //this.cancelToken = axios.CancelToken.source();
         const allEndpoints= this.state.userTransformations;
         const analysisResult= this.state.analyzeResult;
        
        
         
        // const URL = documentPredictionEndPoint(projectName, fileName, outPutFormat);
        try {

             //
             let content = [];
             let userData;
             let udtData;
             let resData;

            // this.setState({ orderResult: content});
            
            this.setState({ apiCompleted: false});
            this.state.orderResult.length = 0;

           // this.state.orderResult.splice(0);

             const ordre=  this.state.orderResult;
            //// IUserEndPoint userTransformations1[] ;// = IUserEndPoint[];
            let  activeep= [] ; // IUserEndPoint[]; //=  IUserEndPoint[];
            activeep= allEndpoints.filter(ep=>ep.active_status  === "enable");

             for (let i = 0; i < activeep.length; i++) {
              // content.push(<li key={item.id}>{item.animal}</li>);
               /* if(i == 0  && allEndpoints[i].category === "AUTH" && allEndpoints[i].active_status === "enable")
                 {
                    // debugger;
                     //make a get call
                       userData =  this.getAuthenticationData(allEndpoints[i]);


                 }*/
               //  debugger;

               const endPointPrefix =  activeep[i].endpoint_name.substring(0,3);


 

                 if( activeep[i].category === "UDT" && activeep[i].active_status === "enable" && endPointPrefix!=="irv")
                 {
                    const dataEndpoint = activeep.find((enpoint) => ( enpoint.category === "SAP" && enpoint.active_status === "enable" && activeep[i].endpoint_name.substring(0,3) !=="irv" ));
                       //make a get call
                        udtData =  this.getUDTData(activeep[i],analysisResult, dataEndpoint) ;
                 }

                 if( activeep[i].category === "UDT" && activeep[i].active_status === "enable" && endPointPrefix==="irv")
                 {
                    const dataEndpoint = activeep.find((enpoint) => ( enpoint.category === "SAP" && enpoint.active_status === "enable" && activeep[i].endpoint_name.substring(0,3) ==="irv"  ));
                       //make a get call
                        udtData =  this.getUDTIRData(activeep[i],dataEndpoint) ;
                 }


                

             }
             //            
        }
     catch (err) {
       // let response;
       let AuthResp;
       let orderResult = this.state.orderResult;
       this.setState({ apiCompleted: true});

       toast.warn( errorSAPMessage, { position: toast.POSITION.TOP_CENTER });
       AuthResp = errorSAPMessage;
       orderResult.push(AuthResp);
      
    }        

    }

    public getAuthenticationData = async (authEndpoint: IUserEndPoint) => {
       // let headers = accessToken();

//debugger;
       var encodedData = base64.encode("DCAP_BATCH"+":"+"Welcome@123");
        const headers = { "x-csrf-token": "fetch",
       //// "Access-Control-Expose-Headers": "*",
       // "Access-Control-Allow-Origin":"*",
       // "Access-Control-Allow-Headers":"*",

        "Access-Control-Expose-Headers": "*",
        "Access-Control-Allow-Origin":"*",
        "Access-Control-Allow-Headers":"*",
    "Authorization":"Basic "+encodedData
    };
       // const endpointURL = analysisGetEndPoint(modelName,analysis)
       const endpointURL = authEndpoint.endpoint;
        let response;
        try {
            response = await ServiceHelper.getWithAutoRetry(
                endpointURL, { headers });
                let AuthResp ;

               // const tokken =  response.headers.get("x-csrf-token");

              //  console.log(pair[0]+ ': '+ pair[1]);
               // const tokken2 =  response.headers.get("status");

               // for (let pair of response.headers.entries()) {
                 //   console.log(pair[0]+ ': '+ pair[1]);
                 // } 

                


                if(response.status=== 200)
                {
                    AuthResp = "Authentication is Successful";
                    toast.success(` Authentication is Successful`, { position: toast.POSITION.TOP_CENTER });
                }
                else
                {
                    AuthResp = "Authentication is not Successful";
                    toast.error(`Authentication is not Successful.`, { position: toast.POSITION.TOP_CENTER });
                }
                
                const autReposne  = {
                    message: AuthResp,
                    type:"Authentication",
                }; 

                let orderResult = this.state.orderResult;
                                           

                orderResult.push(autReposne);
               this.setState({ orderResult: orderResult });
            return response.headers;
        } catch (err) {
            let response;
            toast.error(`Some thing went wrong.`, { position: toast.POSITION.TOP_CENTER });
           
           /*
            if(err.response.status == 401){
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if(response.data.status == 200){
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        response = await ServiceHelper.getWithAutoRetry(
                            endpointURL, { headers });
                        return response.data;
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            }else{
                ServiceHelper.handleServiceError(err);
            }
            */
        }
    }

    public getUDTData = async  (udtEndpoint: IUserEndPoint,analysisResult:any, udtnEndpoint: IUserEndPoint) => {
      
        const errorSAPMessage = "Error while processing the SAP End point";
        const errorUDTMessage = "Error while processing the UDT End point";

        let headers = accessToken()     
       const endpointURL = udtEndpoint.endpoint;
       const formData = new FormData();
       let orderResult = this.state.orderResult;
       
       // debugger;
       const analysisop = {
        "analyze_output":analysisResult
       };

       const analysisoutput =JSON.stringify(analysisop) ;     
        
        let response;
        let AuthResp;
     
        try {        
            
          response = axios(endpointURL, { method: "POST", data: analysisoutput,headers }).
          then((resp)=>
          {
            if(resp.status === 200)
            {
                
            toast.success(` UDT is Successful`, { position: toast.POSITION.TOP_CENTER });        
            AuthResp = "UDT is Successful";
            orderResult.push( AuthResp);
            this.setState({ orderResult: orderResult});                        
            this.setState({  
                UDTResult:resp.data
             });             
             // get the  next call and execute

             //
             /*
             const newSAPData = {
          
               
                  project_name: this.props.match.params["projectName"],
                
                  invoiceNo: "1111",//resp.data.d.invoiceNo,
                  purchaseReq:"22222",//resp.data.d.PurchaseReq
              };
              const body = {};                           
              
              this.props.userDefinedActions.createSAPOrder(newSAPData, body);

              orderResult.push( AuthResp);
              this.setState({ orderResult: orderResult});  
              */
             //
            let resData =  this.getResultOrderData(udtnEndpoint, resp.data) ;
             //
            }           
            else
            {                //other status
                toast.warn(errorUDTMessage, { position: toast.POSITION.TOP_CENTER });
                AuthResp =errorUDTMessage;
                orderResult.push( AuthResp);
                this.setState({ orderResult: orderResult});  
            }
             })
             .catch((error) => {
                // Error 
                this.setState({ apiCompleted: true});
                toast.warn( errorUDTMessage, { position: toast.POSITION.TOP_CENTER });
                if (error.response) { 
                    console.log(error.response);
                }                 
                AuthResp = errorUDTMessage;
                orderResult.push( error.response);
                this.setState({ orderResult: orderResult});  
            });
 
           return response.data;

        } catch (error) {
            this.setState({ apiCompleted: true});
            toast.success( errorUDTMessage, { position: toast.POSITION.TOP_CENTER });
                if (error.response) { 
                    console.log(error.response);
                }                 
                AuthResp = errorUDTMessage;
                orderResult.push( error.response);
                this.setState({ orderResult: orderResult});  
            this.setState({ orderResult: orderResult,
                UDTResult:{}
             });
           //  toast.error(`UDT not Successful..`, { position: toast.POSITION.TOP_CENTER });            
               
        }
    }

    
    public getUDTIRData = async  (udtEndpoint: IUserEndPoint, udtnEndpoint: IUserEndPoint) => {
      
        const errorSAPMessage = "Error while processing the SAP End point";
        const errorUDTMessage = "Error while processing the UDT End point";

        let headers = accessToken()     
       const endpointURL = udtEndpoint.endpoint;
       const formData = new FormData();
       let orderResult = this.state.orderResult;
       
       // debugger;
       const analysisop = {
       // "analyze_output":analysisResult
       };

       const analysisoutput =JSON.stringify(analysisop) ;     
        
        let response;
        let AuthResp;
     
        try {        

                        
const body={};
body["project_name"] =   this.props.match.params["projectName"];//+"-"+this.getUserId();
          
//body["invoiceNo"] =  this.state.vinInvoice? this.state.vinInvoice:"11";
//body["purchase_req"] =  this.state.vinInvoice? this.state.vinInvoice:"11";

body["invoice_no"] =  this.state.vinInvoice? this.state.vinInvoice:"11";
 
          
body["user_id"] =  this.getUserId();;
            if(!this.state.vinInvoice)
            { 
                toast.warn("Error in IR UDT Process", { position: toast.POSITION.TOP_CENTER });
                AuthResp = "Error in IR UDT Process";
                orderResult.push(AuthResp);
                console.log("Stored PUrchange Req is empty==>");
                this.setState({ orderResult: orderResult});  
                return response;
            }
          response = axios(endpointURL, { method: "POST", data: body,headers }).
          then((resp)=>
          {
            if(resp.status === 200)
            {
            toast.success(` IR UDT is Successful`, { position: toast.POSITION.TOP_CENTER });        
            AuthResp = "IR UDT is Successful";
            orderResult.push( AuthResp);

            AuthResp = "IR UDT Invoice Receipt: "+resp.data.Invoice_Rec;
            orderResult.push( AuthResp);

            AuthResp = "IR UDT Purchase Requistion: "+resp.data.PurchaseReq;
            orderResult.push( AuthResp);
 


            this.setState({ orderResult: orderResult});                        
            this.setState({  
                UDTResult:resp.data
             });             
             // get the  next call and execute
            let resData =  this.getResultOrderIRData(udtnEndpoint, resp.data) ;
             //
            }
            else
            {                //other status
                toast.warn(errorUDTMessage, { position: toast.POSITION.TOP_CENTER });
                AuthResp =errorUDTMessage;
                orderResult.push( AuthResp);
                this.setState({ orderResult: orderResult});  
            }
             })
             .catch((error) => {
                // Error 
                this.setState({ apiCompleted: true});
                toast.warn( errorUDTMessage, { position: toast.POSITION.TOP_CENTER });
                if (error.response) { 
                    console.log(error.response);
                }                 
                AuthResp = errorUDTMessage;
                orderResult.push( error.response);
                this.setState({ orderResult: orderResult});  
            });
 
           return response.data;

        } catch (error) {
            this.setState({ apiCompleted: true});
            toast.success( errorUDTMessage, { position: toast.POSITION.TOP_CENTER });
                if (error.response) { 
                    console.log(error.response);
                }                 
                AuthResp = errorUDTMessage;
                orderResult.push( error.response);
                this.setState({ orderResult: orderResult});  
            this.setState({ orderResult: orderResult,
                UDTResult:{}
             });
           //  toast.error(`UDT not Successful..`, { position: toast.POSITION.TOP_CENTER });            
               
        }
    }
    public axiosPromise =  (URL: string, formData) => {
        const headers = accessToken();
       
         return  axios(URL, { method: "POST", data: formData,headers });
  
 
     }
    public getResultOrderData = async (sapEndpoint: IUserEndPoint, udtData: any) => {
       /// let headers = accessToken()     

       const errorSAPMessage = "Error while processing the SAP End point";
       const errorUDTMessage = "Error while processing the UDT End point";

       const endpointURL = sapEndpoint.endpoint;

       const endpointName = sapEndpoint.endpoint_name;
       const epPrefix = sapEndpoint.endpoint_name.substring(0,3);
       //const formData = new FormData();
      // formData.append( analysisResult);

      let orderResult = this.state.orderResult;
      let AuthResp;
     // debugger;
        let response;
        try {
           

       
 

           // const headers = { "x-csrf-token":  userData  };
          // const headers = {   };

           var encodedData = base64.encode("DCAP_BATCH"+":"+"Welcome@123");
        const headers = {  
            "X-Requested-With":"X",
            "Content-Type":"application/json",
    "Authorization":"Basic "+encodedData
    };
 

         response  =  axios(endpointURL, { method: "POST", data: udtData,headers }).
         then((resp)=>
         {
             if(resp.status === 201)
             {
                this.setState({ apiCompleted: true});

                console.log("SAP Response==>"+JSON.stringify(resp.data));
            if(epPrefix === "inv")
            {
                
            AuthResp = "Invoice receipt is created successfully"; 
           toast.success( AuthResp, { position: toast.POSITION.TOP_CENTER });
                      
           orderResult.push( AuthResp);
           AuthResp = "Invoice receipt :"+  resp.data.d.Invoice_No;  
           toast.success( AuthResp, { position: toast.POSITION.TOP_CENTER });          
           orderResult.push( AuthResp);
          //make a call to save the data


          //          
     /*   
const newSAPData = {
          
    endpoint_url: endpointURL,
    endpoint_name: endpointName,    
    project_name: this.props.match.params["projectName"],
    saporderid:resp.data.d.Invoice_No,
    saporderdate: new Date().toDateString(),
};
const body = {};
body["endpoint_name"] = endpointName;
body["endpoint_url"] = endpointURL;
this.props.userDefinedActions.createSAPOrder(newSAPData, body);
*/

          //

           this.setState({ orderResult: orderResult});
            }
            else  if(epPrefix === "sor")
            {
                AuthResp = "Sales order is created successfully"; 
                toast.success( AuthResp, { position: toast.POSITION.TOP_CENTER });                           
                orderResult.push( AuthResp);
                AuthResp = "Sales order:"+  resp.data.d.SalesDoc;  
                toast.success( AuthResp, { position: toast.POSITION.TOP_CENTER });          
                orderResult.push( AuthResp);
                this.setState({ orderResult: orderResult});
            }
            else if(epPrefix === "vin")
            {
                //Vendor Invoice created successfully
                AuthResp = "Purchase Requisition created successfully";  
                toast.success( AuthResp, { position: toast.POSITION.TOP_CENTER });                           
                orderResult.push( AuthResp);
               // AuthResp = "Invoice (with out PO):"+  resp.data.d.Document_no;  
               AuthResp = "Purchase Requisition: "+  resp.data.d.PurchaseReq;  
              
                toast.success( AuthResp, { position: toast.POSITION.TOP_CENTER });          
                orderResult.push( AuthResp);
                AuthResp = "Vendor Invoice number: "+  resp.data.d.Cust_Inv;  
                toast.success( AuthResp, { position: toast.POSITION.TOP_CENTER });   
                orderResult.push( AuthResp);

                  
const newSAPData = {
          
  //  endpoint_url: endpointURL,
  //  endpoint_name: endpointName,    
    project_name: this.props.match.params["projectName"],
   // saporderid:resp.data.d.Invoice_No,
   // saporderdate: new Date().toDateString(),
    invoiceNo:resp.data.d.Cust_Inv,
    purchaseReq:resp.data.d.PurchaseReq,
    status:" ",
};
this.setState({ vinInvoice: newSAPData.invoiceNo});
const body = {};
//body["endpoint_name"] = endpointName;
//body["endpoint_url"] = endpointURL;
//debugger;
console.log ("UDT OUTPUT==>"+ JSON.stringify(udtData));
body["project_name"] = newSAPData.project_name+"-"+this.getUserId();          
body["invoice_no"] =   newSAPData.invoiceNo;
body["purchase_req"] = newSAPData.purchaseReq ;          
body["user_id"] =  this.getUserId();
body["pdf_url"] = udtData.Pdf_url;
 
//body["status"]=newSAPData.status;


this.props.userDefinedActions.createSAPOrder(newSAPData, body);

AuthResp = "Invoice is saved Successfully! ";
orderResult.push( AuthResp);  
              // AuthResp = "Invoice receipt :"+  resp.data.d.Invoice_No;  
toast.success( AuthResp, { position: toast.POSITION.TOP_CENTER }); 
this.setState({ orderResult: orderResult});

            }

            
           this.setState({  
               UDTResult:resp.data
            });
        }
        else
        {
            this.setState({ apiCompleted: true});
            //other status
            toast.warn( errorSAPMessage, { position: toast.POSITION.TOP_CENTER });
                         
            AuthResp = errorSAPMessage;
            orderResult.push( AuthResp);
            this.setState({ orderResult: orderResult}); 
        }
         })
         .catch((error) => {
            // Error 
           
            this.setState({ apiCompleted: true});
             // Error 
             toast.warn( errorSAPMessage, { position: toast.POSITION.TOP_CENTER });
             if (error.response) { 
                 console.log(JSON.stringify(error.response));
             }                 
             AuthResp = errorSAPMessage;
             
             orderResult.push(AuthResp);


             if(error.response.data.error)
             {
                 if(error.response.data.error.message)
                 {
                         orderResult.push(error.response.data.error.message.value);
                 }
                 else
                {
                           orderResult.push(error.response.data.error); 
                  }

             }
             else
             {
                orderResult.push(error.response.data);
             }
                
             this.setState({ orderResult: orderResult}); 
            
        });       
            return response.data;
        } catch (error) {
            this.setState({ apiCompleted: true});
            toast.warn( errorSAPMessage, { position: toast.POSITION.TOP_CENTER });
             if (error.response) { 
                console.log(JSON.stringify(error.response));
             }                 
             AuthResp = errorSAPMessage;
             orderResult.push( error.response);
             this.setState({ orderResult: orderResult});
           
        }
    }

    public getUserId = () => {
        const signInUserSession = localStorage.getItem("signInUserSession");
        const user = signInUserSession && JSON.parse(signInUserSession);
        const userId = user && user.user.oid;
        return userId;
    };
    public getResultOrderIRData = async (sapEndpoint: IUserEndPoint, udtData: any) => {
        /// let headers = accessToken()     
 
        debugger;
        const errorSAPMessage = "Error while processing the IR SAP End point";
        const errorUDTMessage = "Error while processing the IR UDT End point";
 
        const endpointURL = sapEndpoint.endpoint;
 
        const endpointName = sapEndpoint.endpoint_name;
        const epPrefix = sapEndpoint.endpoint_name.substring(0,3);
        //const formData = new FormData();
       // formData.append( analysisResult);
 
       let orderResult = this.state.orderResult;
       let AuthResp;
      // debugger;
         let response;
         try {
            
            // const headers = { "x-csrf-token":  userData  };
           // const headers = {   };
 
            var encodedData = base64.encode("DCAP_BATCH"+":"+"Welcome@123");
         const headers = {  
             "X-Requested-With":"X",
             "Content-Type":"application/json",
     "Authorization":"Basic "+encodedData
     };
     //const irudtop ={"PR_INV_Association": [{"Material": "Ethanol", "TargetQty": "10", "PurchaseReq": " ", "Items": " "}],
      //"InvoiceNo": "11", "PurchaseReq": "0010000359"};


      //const irudtop ={"Invoice_Rec": "11", "PurchaseReq": "10000359"}
    // const irudtop = JSON.stringify(udtData);
  
 console.log("IR Ressponse==>"+udtData);
          response  =  axios(endpointURL, { method: "POST", data:  udtData,headers }).
          then((resp)=>
          {
              if(resp.status === 201)
              {
                 this.setState({ apiCompleted: true});
 
                 console.log("SAP IR Response==>"+JSON.stringify(resp.data));
             if(epPrefix === "inv")
             {              
             
 
             }
             else  if(epPrefix === "sor")
             {
               
             }
             else if(epPrefix === "vin")
             {
             }
             else if(epPrefix === "irv")
             {             
                 //Vendor Invoice created successfully
                 AuthResp = " IR SAP is successful";  
                 toast.success( AuthResp, { position: toast.POSITION.TOP_CENTER });                           
                 orderResult.push( AuthResp);
                // AuthResp = "Invoice (with out PO):"+  resp.data.d.Document_no;  

              
                AuthResp = "IR SAP Invoice:"+  resp.data.d.Invoice_Rec;  
                 toast.success( AuthResp, { position: toast.POSITION.TOP_CENTER });          
                 orderResult.push( AuthResp);  
                   
 const newSAPData = {   
     project_name: this.props.match.params["projectName"],   
     invoiceNo:resp.data.d.Invoice_Rec,
     purchaseReq:resp.data.d.PurchaseReq,
     status:resp.data.d.Invoice_Rec?resp.data.d.Invoice_Rec:"",
 };
 const body = {};
 body["project_name"] = newSAPData.project_name+"-"+this.getUserId();          
body["invoice_no"] = udtData.Invoice_Rec;  //newSAPData.invoiceNo;
body["purchase_req"] = newSAPData.purchaseReq ;          
body["user_id"] =  this.getUserId();;
body["status"]= "success";
 
body["invoice_ir_no"]=resp.data.d.Invoice_Rec;
 //body["endpoint_name"] = endpointName;
 //body["endpoint_url"] = endpointURL;
 this.props.userDefinedActions.createSAPOrder(newSAPData, body);
 
 AuthResp = "IR Status is updated Successfully! ";
 orderResult.push( AuthResp);  
               // AuthResp = "Invoice receipt :"+  resp.data.d.Invoice_No;  
 toast.success( AuthResp, { position: toast.POSITION.TOP_CENTER }); 
 this.setState({ orderResult: orderResult});
 
             }
 
             
            this.setState({  
                UDTResult:resp.data
             });
         }         
         else
         {
             this.setState({ apiCompleted: true});
             //other status
             toast.warn( errorSAPMessage, { position: toast.POSITION.TOP_CENTER });
                          
             AuthResp = errorSAPMessage;
             orderResult.push( AuthResp);
             this.setState({ orderResult: orderResult}); 
         }
          })
          .catch((error) => {
             // Error 
            
             this.setState({ apiCompleted: true});
              // Error 
              toast.warn( errorSAPMessage, { position: toast.POSITION.TOP_CENTER });
              if (error.response) { 
                  console.log(JSON.stringify(error.response));
              }                 
              AuthResp = errorSAPMessage;
              
              orderResult.push(AuthResp);
 
              if(error.response.data.error)
              {
                  if(error.response.data.error.message)
                  {

                    //write error message to azure db
                     //const irudtop ={"Invoice_Rec": "11", "PurchaseReq": "10000359"}
                     const newSAPData = {   
                        project_name: this.props.match.params["projectName"],   
                        invoiceNo:udtData.Invoice_Rec,
                        purchaseReq:udtData.PurchaseReq,
                        status:error.response.data.error.message.value,
                    };
                    const body = {};
                    body["project_name"] = newSAPData.project_name+"-"+this.getUserId();          
                   body["invoice_no"] =   newSAPData.invoiceNo;
                   body["purchase_req"] = newSAPData.purchaseReq ;          
                   body["user_id"] =  this.getUserId();;
                   body["status"]=error.response.data.error.message.value;
                   body["invoice_ir_no"]=" ";
                    //
                    this.props.userDefinedActions.createSAPOrder(newSAPData, body);
                          orderResult.push(error.response.data.error.message.value);
                  }
                  else
                 {
                            orderResult.push(error.response.data.error); 
                   }
 
              }
              else
              {
                 orderResult.push(error.response.data);
              }
                 
              this.setState({ orderResult: orderResult}); 
             
         });       
             return response.data;
         } catch (error) {
             this.setState({ apiCompleted: true});
             toast.warn( errorSAPMessage, { position: toast.POSITION.TOP_CENTER });
              if (error.response) { 
                 console.log(JSON.stringify(error.response));
              }                 
              AuthResp = errorSAPMessage;
              orderResult.push( error.response);
              this.setState({ orderResult: orderResult});
            
         }
     }

}
